export {default} from './PromoteListingListModel';
export * from './PromoteListingListModel';



// WEBPACK FOOTER //
// ./src/models/PromoteListingListModel/index.ts